module.exports = __webpack_public_path__ + "img/gz.4b28157c.png";